import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { createState, useState, Downgraded } from '@hookstate/core';
// import CKEditor from 'ckeditor4-react';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import { exitTheme } from '../../hookState/ThemeState';
import { useAuthState } from '../../stores/authStore';
// import utility and constants
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Title from '../../sharedcomponents/title/title';
import UploadImagePopup from '../../sharedcomponents/uploadImage/uploadImagePopup';
import ProfileImage from '../../sharedcomponents/profileImage/profileImage';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
// import images
import pic from '../../assets/images/pic.svg';
import trash from '../../assets/images/trash.svg';
import AddIcon from '../../assets/images/add_icon.svg';

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';

const useStyles = makeStyles({
    pic: {
        height: 100,
        width: 100,
    },
    add: {
        height: 20,
        width: 20,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const profileState = createState({
    firstName: '',
    lastName: '',
    fNameError: false,
    fNameErrorMsg: '',
    lNameError: false,
    lNameErrorMsg: '',
    dob: Helper.FormatYearDate(new Date()),
    emailList: [{ email: null, emailError: false, emailErrorMsg: '' }],
    phoneList: [{ phone: '', phoneError: false, phoneErrorMsg: '' }],
    address: '',
    picture: '',
    src: '',
    editorHTML: '',
    emailError: false,
    emailErrorMsg: '',
    isDisable: false,
    phoneError: false,
    phoneErrorMsg: '',
    uniqueEmail: '',
    picUrl: '',
});

const Profile = () => {
    const classes = useStyles();
    const authState = useAuthState();
    const state = useState(profileState);
    const history = useHistory();
    const loading = useState(false);
    const userInfo = useState(null);
    const openUpload = useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() => {
        const userInfoValue = Helper.getStorage('userInfo');
        userInfo.set(userInfoValue);
        resetState();
        getUserProfile(userInfoValue.userID);
        exitTheme();
    }, []);

    const resetState = () => {
        state.set({
            firstName: '',
            lastName: '',
            fNameError: false,
            fNameErrorMsg: '',
            lNameError: false,
            lNameErrorMsg: '',
            dob: Helper.FormatYearDate(new Date()),
            emailList: [{ email: null, emailError: false, emailErrorMsg: '' }],
            phoneList: [{ phone: '', phoneError: false, phoneErrorMsg: '' }],
            address: '',
            picture: '',
            src: '',
            editorHTML: '',
            emailError: false,
            emailErrorMsg: '',
            isDisable: false,
            phoneError: false,
            phoneErrorMsg: '',
            uniqueEmail: '',
            picUrl: '',
        });
    };

    const getUserProfile = (userId) => {
        loading.set(true);
        ApiHelper.post(APIURLConstants.GET_USER_PROFILE, {userID: userId})
            .then((res) => {
                if (res.data) state.firstName.set(res.data.firstName);
                state.lastName.set(res.data.lastName);
                if (res.data.picUrl) {
                    const url = res.data.profilePicUrl;
                    state.src.set(url);
                    state.picUrl.set(res.data.picUrl);
                }

                state.dob.set(res.data.dob);
                state.address.set(res.data.userAddress);

                let globalArr = [];
                let arr = res.data.alternateEmails;
                globalArr.push({
                    email: res.data.email.trim(),
                    emailError: false,
                    emailErrorMsg: '',
                });
                if (arr) {
                    let ans = arr.split(';');
                    ans.forEach(function (obj) {
                        globalArr.push({
                            email: obj.trim(),
                            emailError: false,
                            emailErrorMsg: '',
                        });
                    });
                }
                state.emailList.set(globalArr);

                let globalArr2 = [];
                let arr2 = res.data.alternateContacts;
                globalArr2.push({
                    phone: res.data.contactNo,
                    phoneError: false,
                    phoneErrorMsg: '',
                });
                if (arr2) {
                    let ans2 = arr2.split(';');
                    ans2.forEach(function (obj) {
                        globalArr2.push({
                            phone: obj,
                            phoneError: false,
                            phoneErrorMsg: '',
                        });
                    });
                }
                state.phoneList.set(globalArr2);
                state.editorHTML.set(res.data.aboutInfo === "null" ? '' : res.data.aboutInfo);

                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const handleBtnCancel = () => {
        history.push(RouteConstants.DASHBOARD);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        state.uniqueEmail.set('');

        var emailArray = state.emailList.get();
        var alreadySeen = [];
        let newEmailArray = [];

        if (emailArray) {
            emailArray.forEach(function (obj) {
                newEmailArray.push(obj.email);
            });
        }

        newEmailArray.forEach(function (str) {
            if (alreadySeen[str]) {
                state.uniqueEmail.set(str);
            } else {
                alreadySeen[str] = true;
            }
        });

        let arr = state.emailList.get();
        let element = 'Please enter valid Email';
        const getIsDisable = eleContainsInArray(arr, element);

        let phoneArr = state.phoneList.get();
        let errMsg = 'Please enter valid phone number';
        const getPhoneDisable = checkPhoneError(phoneArr, errMsg);

        if (
            getIsDisable ||
            getPhoneDisable ||
            state.fNameError.get() ||
            state.lNameError.get()
        ) {
            //setSnackBarProps({ ...snackBarProps, openSnack: true, variant: 'error', message: '' });
        } else if (!state.uniqueEmail.get() == '') {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'This email already exists.',
            });
        } else {
            let email = '';
            let contact = '';
            let emailInfoArray = [];
            let contactInfoArray = [];
            let array = state.emailList.attach(Downgraded).get();
            array.map((obj, index) => {
                if (index != 0) {
                    emailInfoArray.push(obj.email);
                }
            });
            email = array[0].email;

            let array1 = state.phoneList.attach(Downgraded).get();
            array1.map((obj, index) => {
                if (index != 0) {
                    contactInfoArray.push(obj.phone);
                }
            });
            contact = array1[0].phone;

            // let requestObj = {};

            let requestObj = new FormData();
            requestObj.append('userID', userInfo.get().userID);
            requestObj.append('firstName', state.firstName.get());
            requestObj.append('lastName', state.lastName.get());
            requestObj.append('email', email);
            requestObj.append('contactNo', contact);
            requestObj.append('emailInfo', emailInfoArray);
            requestObj.append('contactInfo', contactInfoArray);
            requestObj.append('userAddress', state.address.get());
            requestObj.append('aboutInfo', state.editorHTML.get());
            requestObj.append('alternateEmails', '');
            requestObj.append('alternateContacts', '');
            requestObj.append('oldPicUrl', state.picUrl.get() ? state.picUrl.get() : '');
            requestObj.append('picUrl', state.picture.attach(Downgraded).get() ? state.picture.attach(Downgraded).get().name : (state.picUrl.get() ? state.picUrl.get() : ''));
            requestObj.append('profilePic', state.picture.attach(Downgraded).get());

            loading.set(true);
            state.isDisable.set(true);
            ApiHelper.post(APIURLConstants.POST_USER_PROFILE, requestObj)
                .then((res) => {
                    if (res.data) {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'User Profile updated successfully',
                        });
                        setTimeout(() => {
                            // use this code to update profile pic in header as well
                            if (state.picture.attach(Downgraded).get()) {
                                const newAuthState = authState.attach(Downgraded).get();
                                newAuthState.appDetails.letsgoUser.picUrl = state.picture.attach(Downgraded).get().name;
                                newAuthState.appDetails.letsgoUser.profilePicUrl = res.data.profilePic;// state.picture.attach(Downgraded).get().name;
                                authState.set(newAuthState);
                            }
                            state.isDisable.set(false);
                            history.push(RouteConstants.DASHBOARD);
                        }, 2000);
                        loading.set(false);
                    }
                })
                .catch((error) => {
                    loading.set(false);
                    state.isDisable.set(false);
                    if (error.response && error.response.status === 401) {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    const eleContainsInArray = (arr, element) => {
        if (arr != null && arr.length > 0) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].emailErrorMsg == element) return true;
            }
        }
        return false;
    };

    const checkPhoneError = (arr, element) => {
        if (arr != null && arr.length > 0) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].phoneErrorMsg == element) return true;
            }
        }
        return false;
    };

    const handleEmailChange = (event, i) => {
        const values = [...state.attach(Downgraded).get().emailList];
        values[i].email = event;
        values[i].emailError = state.emailError.get();
        values[i].emailErrorMsg = state.emailErrorMsg.get();
        state.emailList.set(values);
        //state.isDisable.set(getIsDisable)
    };

    const handleEmailAdd = () => {
        const values = state.attach(Downgraded).get().emailList;
        values.push({ email: null, emailError: false, emailErrorMsg: '' });
        state.emailList.set(values);
    };

    const handleEmailRemove = (i) => {
        const values = [...state.attach(Downgraded).get().emailList];
        values.splice(i, 1);
        state.emailList.set(values);
    };

    const handlePhoneChange = (event, i) => {
        const values = [...state.attach(Downgraded).get().phoneList];
        values[i].phone = event.target.value;
        values[i].phoneError = state.phoneError.get();
        values[i].phoneErrorMsg = state.phoneErrorMsg.get();
        state.phoneList.set(values);
    };

    const checkValidPhone = (e, index) => {
        const phone = e.target.value;
        if (phone != '' && phone != '(___) ___-____') {
            if (
                phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
            ) {
                state.phoneErrorMsg.set('');
                state.phoneError.set(false);
            } else {
                state.phoneErrorMsg.set('Please enter valid phone number');
                state.phoneError.set(true);
            }
        } else {
            state.phoneErrorMsg.set('');
            state.phoneError.set(false);
        }
        handlePhoneChange(e, index);
    };

    const handlePhoneAdd = () => {
        const values = state.attach(Downgraded).get().phoneList;
        values.push({ phone: null, phoneError: false, phoneErrorMsg: '' });
        state.phoneList.set(values);
    };

    const handlePhoneRemove = (i) => {
        const values = [...state.attach(Downgraded).get().phoneList];
        values.splice(i, 1);
        state.phoneList.set(values);
    };



    function ValidateEmail(event, index) {
        const value = event.target.value.trim();
        //if (validator.isEmail(event.target.value)) {
        if (Helper.validEmail(value)) {
            state.emailError.set(false);
            state.emailErrorMsg.set('');
        } else if (value == '') {
            state.emailError.set(false);
            state.emailErrorMsg.set('');
        } else {
            state.emailError.set(true);
            state.emailErrorMsg.set('Please enter valid Email');
        }

        handleEmailChange(value, index);
    }

    const validateFName = (input) => {
        const value = input.trim();
        if (Helper.validName(value)) {
            state.firstName.set(value.replace(/^\s+/, ''));
            state.fNameError.set(false);
            state.fNameErrorMsg.set('');
        } else {
            state.fNameError.set(true);
            state.fNameErrorMsg.set('Please enter valid first name');
            state.firstName.set(value.replace(/^\s+/, ''));
        }
    };

    const validateLName = (input) => {
        const value = input.trim();
        if (Helper.validName(value)) {
            state.lNameError.set(false);
            state.lNameErrorMsg.set('');
            state.lastName.set(value.replace(/^\s+/, ''));
        } else {
            state.lNameError.set(true);
            state.lNameErrorMsg.set('Please enter valid last name');
            state.lastName.set(value.replace(/^\s+/, ''));
        }
    };

    const handleImageUpload = () => {
        openUpload.set(true);
    };
    const handleClose = () => {
        openUpload.set(false);
    };
    const changeProfilePhoto = (file) => {
        if (file.size >= 5000000) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Image File is too big',
            });
        }
        else {
            state.picture.set(file);
            state.src.set(URL.createObjectURL(file));
            handleClose();
        }

    };
    const setEditorValue = (value) => {
        state.editorHTML.set(value);
    }
    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <Box
                        component="form"
                        sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
                        onSubmit={handleSubmit}>
                        <Box
                            sx={{
                                p: 1,
                            }}>
                            <Title title="Primary Information" />

                            <Box
                                sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    marginTop: 3,
                                }}>
                                <Box
                                    sx={{
                                        flex: 0.2,
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                    }}>
                                    <label>
                                        {state.src.get() ? (
                                            <ProfileImage
                                                handleClick={handleImageUpload}
                                                src={state.src.get()}
                                            />
                                        ) : (
                                            <ProfileImage
                                                handleClick={handleImageUpload}
                                                src={pic}
                                            />
                                        )}

                                    </label>

                                    <Typography
                                        variant="h4"
                                        fontSize={{ xs: '12px', md: '12px' }}
                                        fontWeight={500}
                                        paddingTop={1}
                                        color='primary'>
                                        Add Headshot
                                    </Typography>
                                    <Typography
                                        variant="p"
                                        fontSize={{ xs: '10px', md: '10px' }}
                                        fontWeight={400}
                                        paddingTop={1}>
                                        Maximum upload file size: 5 MB.

                                    </Typography>
                                    <Typography
                                        variant="p"
                                        fontSize={{ xs: '10px', md: '10px' }}
                                        fontWeight={400}
                                        paddingTop={0}>
                                        File format: jpg, png, gif

                                    </Typography>
                                </Box>
                                <Box sx={{ flex: 0.8 }}>
                                    <Box
                                        sx={{
                                            flex: 1,
                                            flexDirection: {
                                                xs: 'column',
                                                md: 'row',
                                            },
                                            display: 'flex',
                                        }}>
                                        <Box
                                            sx={{
                                                flex: 0.5,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}>
                                            <TextField
                                                error={state.fNameError.get()}
                                                required
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: '90%',
                                                    },
                                                    marginTop: 2,
                                                }}
                                                size="small"
                                                id="outlined-required"
                                                label="First Name"
                                                value={state.firstName.get()}
                                                onChange={(event) =>
                                                    validateFName(
                                                        event.target.value
                                                    )
                                                }
                                                helperText={state.fNameErrorMsg.get()}
                                            />
                                        </Box>
                                        <Box
                                            sx={{ flex: 0.5, display: 'flex' }}>
                                            <TextField
                                                error={state.lNameError.get()}
                                                required
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: '90%',
                                                    },
                                                    marginTop: 2,
                                                }}
                                                size="small"
                                                id="outlined-required"
                                                label="Last Name"
                                                value={state.lastName.get()}
                                                onChange={(event) =>
                                                    validateLName(
                                                        event.target.value
                                                    )
                                                }
                                                helperText={state.lNameErrorMsg.get()}
                                            />
                                        </Box>
                                    </Box>

                                    <Typography
                                        variant="h4"
                                        fontSize={{ xs: '12px', md: '10px' }}
                                        fontWeight={400}
                                        color="#AC394C"
                                        paddingLeft={1}
                                        marginTop={2}
                                        pb={1}>
                                        Note : Please note that, first & last
                                        name should be exact match to your
                                        official documents.
                                    </Typography>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            flexDirection: {
                                                xs: 'column',
                                                md: 'row',
                                            },
                                            display: 'flex',
                                        }}>
                                        <Box
                                            sx={{
                                                flex: 0.5,
                                                flexDirection: 'column',
                                                display: 'flex',
                                                marginTop: 1,
                                            }}>
                                            {state.emailList
                                                .attach(Downgraded)
                                                .get().length > 0 &&
                                                state.emailList
                                                    .attach(Downgraded)
                                                    .get()
                                                    .map((item, index) => {
                                                        return (
                                                            <Box
                                                                key={index}
                                                                sx={{
                                                                    flexDirection:
                                                                        'row',
                                                                    marginTop: 2,
                                                                }}>
                                                                <TextField
                                                                    error={
                                                                        item.emailError
                                                                    }
                                                                    required
                                                                    sx={{
                                                                        width: '90%',
                                                                    }}
                                                                    size="small"
                                                                    id="outlined-required"
                                                                    label="Email"
                                                                    helperText={
                                                                        item.emailErrorMsg
                                                                    }
                                                                    value={
                                                                        item.email
                                                                    }
                                                                    onChange={(
                                                                        event
                                                                    ) => {
                                                                        ValidateEmail(
                                                                            event,
                                                                            index
                                                                        );
                                                                    }}
                                                                />
                                                                {index == 0 && (
                                                                    <Box
                                                                        component="img"
                                                                        alt="pic."
                                                                        src={
                                                                            AddIcon
                                                                        }
                                                                        className={
                                                                            classes.add
                                                                        }
                                                                        sx={{
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            marginLeft: 1,
                                                                            marginTop: 1,
                                                                        }}
                                                                        onClick={
                                                                            handleEmailAdd
                                                                        }
                                                                    />
                                                                )}
                                                                {index > 0 && (
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.add
                                                                        }
                                                                        alt="delete"
                                                                        src={
                                                                            trash
                                                                        }
                                                                        sx={{
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            marginLeft: 1,
                                                                            marginTop: 1,
                                                                        }}
                                                                        onClick={() =>
                                                                            handleEmailRemove(
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                        </Box>
                                        <Box
                                            sx={{
                                                flex: 0.5,
                                                flexDirection: 'column',
                                                display: 'flex',
                                                marginTop: 1,
                                            }}>
                                            {state.phoneList
                                                .attach(Downgraded)
                                                .get().length > 0 &&
                                                state.phoneList
                                                    .attach(Downgraded)
                                                    .get()
                                                    .map((item, index) => {
                                                        return (
                                                            <Box
                                                                key={index}
                                                                sx={{
                                                                    flexDirection:
                                                                        'row',
                                                                    marginTop: 2,
                                                                }}>
                                                                <InputMask
                                                                    mask="(999) 999-9999"
                                                                    value={
                                                                        item.phone
                                                                    }
                                                                    defaultValue={
                                                                        item.phone
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        //handlePhoneChange(e,index)
                                                                        checkValidPhone(
                                                                            e,
                                                                            index
                                                                        );
                                                                    }}>
                                                                    {() => (
                                                                        <TextField
                                                                            error={
                                                                                item.phoneError
                                                                            }
                                                                            text
                                                                            value={
                                                                                item.phone
                                                                            }
                                                                            label="Phone Number"
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            size="small"
                                                                            sx={{
                                                                                width: '90%',
                                                                            }}
                                                                            helperText={
                                                                                item.phoneErrorMsg
                                                                            }
                                                                        />
                                                                    )}
                                                                </InputMask>

                                                                {index == 0 && (
                                                                    <Box
                                                                        component="img"
                                                                        alt="pic."
                                                                        src={
                                                                            AddIcon
                                                                        }
                                                                        className={
                                                                            classes.add
                                                                        }
                                                                        sx={{
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            marginLeft: 1,
                                                                            marginTop: 1,
                                                                        }}
                                                                        onClick={
                                                                            handlePhoneAdd
                                                                        }
                                                                    />
                                                                )}
                                                                {index > 0 && (
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.add
                                                                        }
                                                                        alt="delete"
                                                                        src={
                                                                            trash
                                                                        }
                                                                        sx={{
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            marginLeft: 1,
                                                                            marginTop: 1,
                                                                        }}
                                                                        onClick={() =>
                                                                            handlePhoneRemove(
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            flexDirection: 'row',
                                            display: 'flex',
                                            marginTop: 2,
                                        }}>
                                        <TextField
                                            size="small"
                                            required
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '95%',
                                                },
                                            }}
                                            id="outlined-required"
                                            label="Address"
                                            value={state.address.get()}
                                            onChange={(event) =>
                                                state.address.set(
                                                    event.target.value
                                                )
                                            }
                                            multiline={true}
                                            inputProps={{ maxLength: 255 }}
                                            minRows={3}
                                            maxRows={10}
                                        />
                                    </Box>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            flexDirection: 'row',
                                            marginTop: 2,
                                            width: { xs: '100%', md: '95%' },
                                        }}>
                                        {/* <CKEditor
                                            data={state.editorHTML
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(event) =>
                                                state.editorHTML.set(
                                                    event.editor.getData()
                                                )
                                            }
                                            config={{
                                                removeButtons: 'Subscript,Superscript',
                                                extraAllowedContent: '*{*};*(*);span{!color}'
                                            }}
                                        /> */}
                                        <TinyMCEEditor
                                            value={state.editorHTML
                                                .attach(Downgraded)
                                                .get()}
                                            setValue={setEditorValue}                
                                        />
                                        {/* <CKEditor 
                                            editor={Editor}
                                            config={{
                                                image: {
                                                    upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                                                },
                                                removeButtons: 'Subscript,Superscript',
                                                extraAllowedContent: '*{*};*(*);span{!color}'
                                            }}
                                            data={state.editorHTML
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(event, editor) => {
                                                console.log(event);
                                                state.editorHTML.set(
                                                    editor.getData()
                                                )
                                            }}
                                        /> */}
                                    </Box>
                                </Box>
                            </Box>

                            <Divider
                                light={false}
                                sx={{ marginTop: 10, marginRight: 0 }}
                                flexItem
                            />

                            <ButtonContainer
                                //handleClick={handleClick}
                                handleCancel={handleBtnCancel}
                                buttonText={'Save'}
                                disableButton={state.isDisable.get()}
                            />
                        </Box>
                        {snackBarProps.openSnack && (
                            <CustomizedSnackbars
                                {...snackBarProps}
                                onClose={() =>
                                    setSnackBarProps({
                                        ...snackBarProps,
                                        openSnack: false,
                                    })
                                }></CustomizedSnackbars>
                        )}
                    </Box>
                </Box>
            )}
            {openUpload.get() && (
                <UploadImagePopup
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    open={openUpload.get()}
                    title="Upload Image"
                    handleClose={handleClose}
                    changeProfilePhoto={changeProfilePhoto}
                />
            )}
        </>
    );
};

export default {
    routeProps: {
        path: '/profile',
        component: Profile,
    },
    name: 'Profile',
};
